<div class="flex h-screen overflow-hidden bg-page relative">

  <!-- Mobile drawer backdrop overlay -->
  @if (sidebar.isMobile() && sidebar.open()) {
  <div class="absolute inset-0 bg-[#0E1116]/45 z-40 transition-opacity duration-200 sm:hidden"
    (click)="sidebar.close()"></div>
  }

  <!-- Responsive Sidebar Container -->
  <div class="h-full overflow-hidden transition-[width] duration-200 ease-out shrink-0 bg-nav z-50
               max-sm:absolute max-sm:left-0 max-sm:top-0 max-sm:shadow-2xl max-sm:h-screen"
    [class.w-[220px]]="sidebar.open()" [class.w-[56px]]="!sidebar.open() && sidebar.isTabletOrDesktop()"
    [class.w-0]="!sidebar.open() && sidebar.isMobile()">
    <app-sidebar [navItems]="navItems" companyName="WorkWell" [userName]="userName"
      [userRole]="userRole" [userInitials]="userInitials" (logout)="auth.logout()"
      [collapsed]="sidebar.isMobile() ? false : !sidebar.open()" />
  </div>

  <!-- Main Layout Surface -->
  <div class="flex flex-col flex-1 min-w-0 overflow-hidden">
    @if (showTopbar) {
      <app-topbar searchPlaceholder="Search..." [userName]="userName" [userRole]="userRole" [userInitials]="userInitials"
        [activeFilterCount]="(dashboardState.activeFilterCount$ | async) ?? 0"
        [showDashboardControls]="showDashboardControls" />
    }
    <main class="flex-1 min-h-0 overflow-y-auto bg-page flex flex-col">
      <!-- Centralised Max-Width layout container for premium large desktop focus -->
      <div class="w-full max-w-[1600px] lg:max-w-none mx-auto flex-1 flex flex-col min-h-0">
        <router-outlet />
      </div>
    </main>
  </div>

</div>

<p-dialog
  header="Xero Reconnect Required"
  [(visible)]="showXeroReconnectDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(28rem, calc(100vw - 2rem))' }"
>
  <div class="flex items-start gap-3">
    <div class="w-10 h-10 rounded-full bg-caut-bg text-caution flex items-center justify-center shrink-0">
      <i class="pi pi-exclamation-triangle"></i>
    </div>
    <div>
      <p class="text-sm text-dim mb-3">
        Your Xero connection is no longer active. Reconnect it to resume live syncing.
      </p>
      <button
        type="button"
        class="text-sm font-semibold text-primary hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary rounded"
        (click)="openXeroIntegrationSettings()"
      >
        Xero Reconnect Required
      </button>
    </div>
  </div>
</p-dialog>
